import React, { useEffect, useState } from "react";
import Loader from "../common/Loader";
import { dateFunction } from "../../utils/dateFunction";
import { useFinance } from "../../hooks/useFinance";
import { currencyFormatter } from "../../utils/currencyFormatter";

const BookingPayment = ({
  transaction,
  loading,
}: {
  transaction: any;
  loading: any;
}) => {
  console.log("transaction data", transaction);

  const { getWallet } = useFinance();
  const [wallet, setWallet] = useState<number>(0);
  useEffect(() => {
    const fetchWallet = async () => {
      const response = await getWallet();
      setWallet(response.amount);
    };
    fetchWallet();
  }, []);

  // Date formatting function

  return (
    <div>
      {loading ? (
        <div className="mt-32">
          <Loader loading={loading} />
        </div>
      ) : (
        <div className="bg-gray-50 min-h-screen">
          {/* Page Header */}
          <h1 className="text-2xl font-semibold mt-10 mb-6">Finance</h1>

          <div className="grid grid-cols-2 gap-4 mt-6 bg-white p-4 rounded-lg shadow">
            <div>
              <p className="text-gray-500">Your balance (NGN)</p>
              <p className="text-3xl font-semibold">
                {wallet?.toFixed(2)?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") ||
                  "0.00"}
              </p>
            </div>
            <div>
              <p className="text-gray-500">Next Payout (NGN)</p>
              <p className="text-3xl font-semibold">
                {transaction?.transactions
                  ?.filter(
                    (t: any) =>
                      t.status === "pending" &&
                      t.owner?._id === transaction?.user?._id
                  )
                  ?.reduce((sum: number, t: any) => sum + t.amount, 0)
                  ?.toFixed(2)
                  ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "0.00"}
              </p>
            </div>
          </div>

          <div className="mt-6 bg-white rounded-lg shadow overflow-hidden">
            <div className="overflow-x-auto">
              <table className="min-w-full border-collapse whitespace-nowrap">
                <thead className="bg-gray-100 text-gray-600 text-sm uppercase">
                  <tr>
                    <th className="p-3 text-left">Booking Reference</th>
                    <th className="p-3 text-left">Lead Traveler</th>
                    <th className="p-3 text-left">Product Code</th>
                    <th className="p-3 text-left">Option Code</th>
                    <th className="p-3 text-left">Activity Date</th>
                    <th className="p-3 text-left">Date of Purchase</th>
                    <th className="p-3 text-left">Retail Rate</th>
                    <th className="p-3 text-left">Net Rate</th>
                  </tr>
                </thead>
                <tbody className="text-gray-700">
                  {transaction?.map((item: any, index: any) => (
                    <tr
                      key={index}
                      className={`${
                        index % 2 === 0 ? "bg-gray-50" : "bg-white"
                      } hover:bg-gray-100`}
                    >
                      <td className="p-3">{item.reference}</td>
                      <td className="p-3">
                        {item.payer.firstName} {item.payer.lastName}
                      </td>
                      <td className="p-3">{item?.type === "package" ? item?.package?.referenceCode : item?.protocolService?.serviceCode}</td>
                      <td className="p-3">{item?.package?.options?.referenceCode}</td>
                      <td className="p-3">{dateFunction(item.createdAt)}</td>
                      <td className="p-3">
                        {dateFunction(item.transactionDate)}
                      </td>
                      <td className="p-3">{currencyFormatter(item?.amount)}</td>
                      <td className="p-3">{currencyFormatter(item?.psBooking?.baseAmount)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingPayment;
